<template>
  <v-container>
    <v-alert shaped prominent type="error" v-if="notFound">
      El formulario seleccionado no existe o fue imposible recuperar la
      informaicón
    </v-alert>
    <v-progress-circular
      indeterminate
      class="loading"
      color="primary"
      v-if="loading"
    >
      Cargando
    </v-progress-circular>
    <v-layout
      v-else
      class="report"
      :class="{ 'report-down': data != undefined }"
    >
      <v-flex>
        <!-- sections for form -->
        <v-col>
          <p
            class="ministerio"
            :class="{ 'ministerio-print': data != undefined }"
          >
            MINISTERIO DE ECONOMÍA PLANIFICACIÓN Y DESARROLLO (MEPyD)
          </p>
          <v-row align="center" style="margin-bottom: 1%; margin-top: 1%">
            <img class="shield" src="@/assets/escudo.png" />

            <p
              class="one-tittle"
              :class="{ 'one-tittle-print': data != undefined }"
            >
              Oficina Nacional de Estadística
            </p>

            <img class="one-logo" src="@/assets/one_logo_transparent.png" />
          </v-row>
        </v-col>

        <v-list
          v-for="(section, s) in questions"
          :key="s"
          class="question-list"
          :class="{ 'question-list-down': data != undefined }"
        >
          <hr class="divider" />
          <v-card-title class="sub-tittle"
            >Capítulo {{ romanize(section.sectionNumber) }} :
            {{ section.title }}</v-card-title
          >

          <v-row
            align="center"
            style="margin-bottom: 0.5%"
            v-if="loadId(section.sectionNumber)"
          >
            <v-card-title class="question">1.1 ID</v-card-title>

            <label class="answer">
              {{ registro.id }}
            </label>
          </v-row>
          <!-- Questions it self -->

          <v-list
            v-for="(question, i) in section.questions"
            :key="i"
            style="max-width: 100%"
          >
            <v-list-item-content
              v-if="hasData(question) && loadQuestionFromFinal(question, final)"
            >
              <tableAnswerComponentVue
                :question="question"
                class="questionText table-data"
                :disabledAnswers="true"
                v-if="isTableQuestion(question)"
                style="margin-bottom: 2%"
                :questionNumber="getNum(question)"
                :answer="final.get(getNum(question)).answer"
              />
              <v-row align="center" v-if="section.sectionNumber == 1">
                <v-card-title class="question"
                  >{{ question.literalNumber }}
                  {{ question.question }}</v-card-title
                >

                <label class="answer">
                  {{ final.get(getNum(question)).answer }}
                </label>
              </v-row>

              <v-col
                v-if="section.sectionNumber != 1 && !isTableQuestion(question)"
              >
                <v-card-title class="questionGeneral" style="margin-top: -2%"
                  >{{ question.literalNumber }}
                  {{ question.question }}</v-card-title
                >

                <label class="answerGeneral">
                  {{ final.get(getNum(question)).answer }}
                </label>
              </v-col>
            </v-list-item-content>
          </v-list>
        </v-list>
        <finalInfoComponentVue
          class="final-information"
          style="width: 90%; margin-left: 5%; margin-right: 5%; margin-top: 5%"
          :fillingResponsable="registro.fillingResponsable"
          :liftingDate="registro.liftingDate"
          :disabled="true"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { getQuestions, getFormByCode } from "@/utils/apiRequest.js";
import tableAnswerComponentVue from "@/components/tableAnswerComponent.vue";
import { isTableQuestion, getNum, loadQuestionFromFinal } from "@/utils/utils";
import finalInfoComponentVue from "@/components/finalInfoComponent.vue";
export default {
  data() {
    return {
      questions: [],
      parsedResponse: new Map(),
      final: new Map(),
      demo: false,
      shouldLoadID: true,

      loading: true,
      registro: {},
      option: new Map(),
      notFound: false,
      romans: new Map(),
    };
  },

  computed: {
    isDataLoaded() {
      return this.registro.answers != null;
    },
  },
  components: {
    tableAnswerComponentVue,
    finalInfoComponentVue,
  },
  methods: {
    getNum,
    loadQuestionFromFinal: loadQuestionFromFinal,
    getAnswerValue(question, registro) {
      let val = "";
      registro.answers.forEach((answer) => {
        if (answer.question == question.question) {
          val = answer.answer;
          return;
        }
      });
      return val;
    },
    romanize(num) {
      if (isNaN(num)) return NaN;
      var digits = String(+num).split(""),
        key = [
          "",
          "C",
          "CC",
          "CCC",
          "CD",
          "D",
          "DC",
          "DCC",
          "DCCC",
          "CM",
          "",
          "X",
          "XX",
          "XXX",
          "XL",
          "L",
          "LX",
          "LXX",
          "LXXX",
          "XC",
          "",
          "I",
          "II",
          "III",
          "IV",
          "V",
          "VI",
          "VII",
          "VIII",
          "IX",
        ],
        roman = "",
        i = 3;
      while (i--) roman = (key[+digits.pop() + i * 10] || "") + roman;
      return Array(+digits.join("") + 1).join("M") + roman;
    },
    hasData(question) {
      return this.final.get(getNum(question)).answer != "";
    },
    loadId(i) {
      if (i == 1) {
        return true;
      }
      return false;
    },
    isTableQuestion: isTableQuestion,
  },
  props: {
    data: Object(),
  },
  async mounted() {
    let response = await getQuestions();
    if (response.data.status == "success") {
      this.questions = response.data.sections;
    }

    if (this.data != undefined) {
      this.registro = this.data;

      this.questions.forEach((section) => {
        section.questions.forEach((question) => {
          let val = this.getAnswerValue(question, this.registro);
          this.final.set(this.getNum(question), {
            question: question,
            answer: val,
          });
        });
      });
      this.evidences = this.registro.evidences;

      this.loading = false;

      return;
    }

    response = await getFormByCode(this.$route.params.id);
    if (response.data.status == "success") {
      let registro = response.data.forms;
      await this.questions.forEach(async (section) => {
        section.questions.forEach((question) => {
          let val = this.getAnswerValue(question, registro);
          this.final.set(this.getNum(question), {
            question: question,
            answer: val,
          });
        });
      });
      this.registro = registro;
      this.evidences = registro.evidences;

      this.loading = false;

      if (window.location.hash == "#print") {
        await new Promise((resolve) => setTimeout(resolve, 450));
        document.title = registro.id;
        window.print();
        window.close();
      }
      return;
    }

    this.loading = false;
    this.notFound = true;
  },
};
</script>

<style scoped>
@media print {
  div .v-list-item__content {
    page-break-inside: avoid;
  }

  div .final-information {
    margin-bottom: -100%;
  }
}

.loading {
  position: absolute;
  left: 50%;
  margin: 25% 0 0 0;
}

.question {
  font-size: medium;
  overflow-wrap: break-word;
  word-break: break-word;
  width: 58.5%;
  font-weight: bold;
  margin-left: 1.5%;
}

.answer {
  font-size: medium;
  overflow-wrap: break-word;
  word-break: normal;
  width: 35%;
}

.questionGeneral {
  font-size: medium;
  overflow-wrap: break-word;
  word-break: break-word;
  width: 100%;
  font-weight: bold;
  margin-left: 1.5%;
}

.answerGeneral {
  font-size: medium;
  overflow-wrap: break-word;
  word-break: normal;
  width: 100%;
  margin-left: 3%;
}

.v-card__title {
  padding: 2px;
}

.divider {
  margin-top: 3%;
  width: 100%;
  height: 4px;
  color: black;
  background-color: black;
  border-width: 100%;
}

.report {
  background-color: white;
  /*   padding: 0 0 716px; */
  display: flex;
  flex-direction: column;
  overflow-wrap: normal;
  word-break: normal;
  align-items: flex-start;
  width: 100%;
  max-width: 1000px;
  width: 1000px;
}

.report-down {
  background-color: white;
  /*   padding: 0 0 716px; */
  display: flex;
  flex-direction: column;
  overflow-wrap: normal;
  word-break: normal;
  align-items: flex-start;
  width: 100%;
  max-width: 800px;
  width: 800px;
}
.ministerio {
  font-weight: bold;
  margin: 0 0 -2% 25%;
  font-size: smaller;
}

.ministerio-print {
  font-weight: bold;
  margin: 0 0 0 15%;
  font-size: smaller;
}

.one-tittle {
  font-weight: bolder;
  margin: 0 0 0 30%;
}
.one-tittle-print {
  font-weight: bolder;
  margin: 0 0 0 20%;
}

.shield {
  width: 60px;
  height: 60px;
  margin-left: 1%;
}

.one-logo {
  width: 90px;
  height: 50px;
  margin-left: 30%;
}

.question-list {
  max-width: 100%;
  margin-top: -5%;
}

.question-list-down {
  max-width: 100%;
  margin-top: -1%;
}

.sub-tittle {
  height: 100%;
  justify-content: center;
  overflow-wrap: normal;
  word-break: normal;
  color: black;
  padding-bottom: 2%;
  font-weight: bolder;
  margin: 0 0 0 5%;
}
</style>